import React from 'react';
import { translate } from '../../../i18n';
import { DialogWithTabs, _translate } from './DialogWithTabs';
import StatelessDialog from './StatelessDialog';

class RPC_DialogWithTabs extends DialogWithTabs {
    constructor(props) {
        super(props);
    }

    render() {
        const onCancel = this.props.closeDialog;

        return (
            <StatelessDialog
                disableBlanketClickDismiss
                    = { this.props.disableBlanketClickDismiss }
                onCancel = { onCancel }
                onSubmit = { this._onSubmit }
                titleKey = { this.props.titleKey }
                okKey = { this.props.okKey }
                customHeader = { this.props.customHeader }
                hideCancelButton = { this.props.hideCancelButton } >
                <div className = { this.props.cssClassName } >
                    { this._renderTabs() }
                </div>
            </StatelessDialog>
        );
    }
}

export default translate(RPC_DialogWithTabs);